import EmployeesDataTable from "../../../components/dataTable/tables/employee/EmployeesDataTable";

function EmployeesPageView() {
  return <EmployeesDataTable />;
}

export default EmployeesPageView;
